import { Route } from '@angular/router';
import { DiscoveryComponent } from './discovery/components/discovery.component';

export const discoveryRoutes: Route[] = [{ path: 'discovery/:id', component: DiscoveryComponent }];
